/**
 * The payload the "Table" slash command sends to INSERT_TABLE_COMMAND.
 *
 * A named constant rather than an inline object literal so a test can assert
 * against THE REAL ONE. Asserting against a literal re-declared in the test is
 * the failure this codebase has shipped before: the test passes while the
 * production call site says something else entirely (skill §3a).
 */
export const NEW_TABLE_CONFIG = {
  columns: '3',
  rows: '3',
  // FALSE, and this is the whole point. In @lexical/table `includeHeaders: true`
  // makes BOTH the first row and the first COLUMN header cells — that is where
  // the two tinted edges came from. A tinted first column implies the left edge
  // is a label axis when usually it is data.
  //
  // A header ROW is still one click away in the hover menu, which is the right
  // way round: opt in when the table has headers rather than opt out every time
  // it does not.
  includeHeaders: false,
};
